<!--
下拉列表字段公告方法
-->
<template>
  <span>
    <Row>
      <Select :size="size" :transfer="true" :multiple="multiple"  filterable @on-change="change" v-model="value" :label="value" :placeholder="placeholder" :clearable="true">
        <Option value="空字段" v-if="kong">空字段</Option>
        <Option v-for="item in detail.data" :value="item.id">{{item.name}}</Option>
        </Select>
       <span  v-if="addbtn">
          <font color="#c5c8ce">找不到想要的字段？</font><a  @click="add">增加字段</a>
      </span>
    </Row>

    <Modal
      v-model="modal1"
      :title="'增加栏目'"
      @on-ok="save">
      <Form :label-width="80">
        <FormItem label="栏目名称" :required="true">
          <Input v-model="form.name" placeholder="输入栏目名称"></Input>
        </FormItem>
      </Form>
    </Modal>

  </span>
</template>

<script>
  export default {
    props:{
      type:{
        type:Number,
      },
      value:{
        type:Number,
        default:0
      },
      placeholder:{
        type:String,
        default:''
      },
      addbtn:{
        type:Boolean,
        default:false,
      },
      size:{
        type:String,
        default:'default'
      },
      multiple:{//是否支持多选
        type:Boolean,
        default:false
      },
      kong:{//是否显示空字段选项
        type:Boolean,
        default:false
      }
    },
    data(){
      return{
        // value:this.value,
        // val:this.value,
        detail:{},
        form:{
          id:0,
          type:0,
          name:''
        },
        modal1:false,
      }

    },
    methods:{
      load(){
        let that = this;
        this.$axios.get('/api/field/get?type='+this.type).then(function(rs){
          that.detail = rs.data;
        });
      },
      change(){
        this.$emit('input',this.value);
        this.$emit('on-change');
      },
      add(){
        this.form.type = this.detail.type;
        this.modal1 = true;
      },
      save(){
        let that = this;
        if(this.form.name==''){
          this.$Message.warning('请输入栏目名称');
          return;
        }
        this.$axios({url:'/api/field/save',method:"post",data:this.$qs.stringify(this.form)}).then(function(rs){
          if(rs.data>0){
            that.$Message.success('操作成功');
            that.load();
            that.value = that.form.name;
            that.$emit('input',that.value);
            that.form.name='';
          }else{
            that.$Message.error('操作失败');
          }
        })
      },
    },
    created(){
      this.load();
    },
    watch:{
      type:{
        handler(newValue, oldValue) {
          this.load();
        },
        deep: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/field/Field2.vue